"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTreeFromSelectedFiles = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// Base type for tree nodes

// Generic type for trees with children

// Helper function to add descendants
var _addDescendants = function addDescendants(parentId, requiredIds, getTeamsFilesByParentId) {
  var children = getTeamsFilesByParentId(parentId);
  var _iterator = _createForOfIteratorHelper(children),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;
      requiredIds.add(child.id);
      if (child.folder) {
        _addDescendants(child.id, requiredIds, getTeamsFilesByParentId);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

// Function to get the ancestor level of a file
var getAncestorLevel = function getAncestorLevel(file, requiredIds, getTeamsFileById) {
  var _file$parentReference;
  var level = 0;
  var currentParentId = (_file$parentReference = file.parentReference) === null || _file$parentReference === void 0 ? void 0 : _file$parentReference.id;
  while (currentParentId && requiredIds.has(currentParentId)) {
    var _parentFile$parentRef;
    level++;
    var parentFile = getTeamsFileById(currentParentId);
    currentParentId = parentFile === null || parentFile === void 0 || (_parentFile$parentRef = parentFile.parentReference) === null || _parentFile$parentRef === void 0 ? void 0 : _parentFile$parentRef.id;
  }
  return level;
};

// Main function to build the tree
var buildTreeFromSelectedFiles = exports.buildTreeFromSelectedFiles = function buildTreeFromSelectedFiles(selectedFiles, getTeamsFilesByParentId, getTeamsFileById, nodeMapper) {
  if (!selectedFiles || selectedFiles.length === 0) return [];

  // Set of all IDs that should be in the tree
  var requiredIds = new Set();

  // Add all files from selectedRows
  var _iterator2 = _createForOfIteratorHelper(selectedFiles),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _file$parentReference3;
      var file = _step2.value;
      requiredIds.add(file.id);

      // SCENARIO 1: If it's a selected folder, add all its descendants
      if (file.folder) {
        _addDescendants(file.id, requiredIds, getTeamsFilesByParentId);
      }

      // SCENARIO 2: Add all ancestors to maintain hierarchy
      var currentParentId = (_file$parentReference3 = file.parentReference) === null || _file$parentReference3 === void 0 ? void 0 : _file$parentReference3.id;
      while (currentParentId) {
        if (requiredIds.has(currentParentId)) {
          break;
        } else {
          var _parentFile$parentRef2;
          requiredIds.add(currentParentId);
          var parentFile = getTeamsFileById(currentParentId);
          currentParentId = parentFile === null || parentFile === void 0 || (_parentFile$parentRef2 = parentFile.parentReference) === null || _parentFile$parentRef2 === void 0 ? void 0 : _parentFile$parentRef2.id;
        }
      }
    }

    // Get all required files
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var requiredFiles = Array.from(requiredIds).map(function (id) {
    return getTeamsFileById(id);
  }).filter(function (file) {
    return file !== undefined;
  });

  // Recursive function to build the tree
  var _buildTree = function buildTree(parentId) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var children = requiredFiles.filter(function (file) {
      var _file$parentReference2;
      return ((_file$parentReference2 = file.parentReference) === null || _file$parentReference2 === void 0 ? void 0 : _file$parentReference2.id) === parentId;
    });
    return children.map(function (file) {
      return _objectSpread(_objectSpread({}, nodeMapper(file, level)), {}, {
        children: _buildTree(file.id, level + 1)
      });
    });
  };

  // Find the MINIMUM ancestor level (closest to root)
  var minLevel = Math.min.apply(Math, _toConsumableArray(requiredFiles.map(function (file) {
    return getAncestorLevel(file, requiredIds, getTeamsFileById);
  })));

  // Root files are those with the MINIMUM ancestor level
  var rootFiles = requiredFiles.filter(function (file) {
    return getAncestorLevel(file, requiredIds, getTeamsFileById) === minLevel;
  });
  var tree = rootFiles.map(function (file) {
    return _objectSpread(_objectSpread({}, nodeMapper(file, 0)), {}, {
      children: _buildTree(file.id, 1)
    });
  });
  return tree;
};